// extracted by mini-css-extract-plugin
export default {"BoutonActionFlottant":"BoutonActionFlottant_BoutonActionFlottant__30nTD","load":"BoutonActionFlottant_load__L5AkP"};